var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { bind } from "decko";
import { GenericInputElement } from "./genericinputfield";
export class TextField extends GenericInputElement {
    constructor(props) {
        super(props);
        this.validators.push(this.createMinLengthValidator(), this.createMaxLengthValidator());
        this.state = Object.assign({}, this.defaultState);
    }
    createMinLengthValidator() {
        return (value) => {
            return {
                valid: this.props.minLength === undefined
                    ? true
                    : value.length >= this.props.minLength,
                validationMessage: this.translate.validation.textTooShort(this.props.minLength),
            };
        };
    }
    createMaxLengthValidator() {
        return (value) => {
            return {
                valid: this.props.maxLength === undefined
                    ? true
                    : value.length <= this.props.maxLength,
                validationMessage: this.translate.validation.textTooLong(this.props.maxLength),
            };
        };
    }
    componentDidMount() {
        this.inputElRef && this.props.javaScriptAutoFocus && this.inputElRef.focus();
    }
    handleChange(event) {
        this.setState({ isPristine: false });
        this.props.onValueChange &&
            this.props.onValueChange(event.target.value, this.validate(event.target.value).length === 0);
    }
    handleKeyDown(event) {
        if (event.key === "Enter") {
            const value = this.inputElRef ? this.inputElRef.value : "";
            this.props.onValueCommit &&
                this.props.onValueCommit(value, this.validate(value).length === 0);
        }
        this.props.onKeyDown && this.props.onKeyDown(event);
    }
    handleBlur(event) {
        const value = this.inputElRef ? this.inputElRef.value : "";
        this.props.onValueCommit &&
            this.props.onValueCommit(value, this.validate(value).length === 0);
        this.props.onBlur && this.props.onBlur(event);
    }
    renderInner() {
        return (React.createElement("input", { autoFocus: this.props.autoFocus, ref: (el) => (this.inputElRef = el), id: this.props.id, type: this.props.type, value: this.props.value, placeholder: this.props.hint, required: this.props.required, disabled: this.props.disabled, onBlur: this.handleBlur, onChange: this.handleChange, onFocus: this.defaultHandleFocus, onKeyDown: this.handleKeyDown, lang: this.props.lang, tabIndex: this.props.tabIndex, autoComplete: this.props.autoComplete }));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextField.prototype, "handleChange", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextField.prototype, "handleKeyDown", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TextField.prototype, "handleBlur", null);
export default TextField;
//# sourceMappingURL=textfield.js.map